export default __webpack_public_path__ + "static/dummy-card-8c623e9647d07a9bba5b66567d92ad58.png";